import Hardpoints from './hardpoints';
export default Hardpoints;
